import React from "react";
import "../styles/Header.css";

const Header = () => {
  return (
    <header className="bg-primary py-5 mb-5">
      <div className="container h-100">
        <div className="row h-100 mt-5">
          <div className="d-flex col-lg-12 justify-content-center mt-5"></div>
        </div>
      </div>
    </header>
  );
};

export default Header;
